import * as React from "react";
import { liteClient } from "algoliasearch/lite";
import { InstantSearchSSRProvider, InstantSearch, Configure } from "react-instantsearch";
import { useAlgoliaConfig } from "./AlgoliaConfig.js";
import { VirtualFacets } from "../components/VirtualFacets/Algolia/components/VirtualFacets/VirtualFacets.js";
import { createAlgoliaRouter } from "./create-algolia-router.js";
function AlgoliaProviders({ children }) {
  const {
    serverState,
    router,
    indexName,
    facets,
    pageSize,
    serverUrl,
    sortIndices,
    presetQueryString,
    apiKey,
    appId
  } = useAlgoliaConfig();
  const searchClient = React.useMemo(() => liteClient(appId, apiKey), [appId, apiKey]);
  return /* @__PURE__ */ React.createElement(InstantSearchSSRProvider, { ...serverState }, /* @__PURE__ */ React.createElement(
    InstantSearch,
    {
      indexName,
      searchClient,
      routing: createAlgoliaRouter({
        router,
        facets,
        indexName,
        pageSize,
        serverUrl,
        sortIndices,
        presetQueryString
      }),
      future: {
        // In order to save algolia refinements (sorting, facets selected, etc.) between desktop/mobile, we need to preserve
        // state when unmounting algolia hooks (otherwise state gets reset).
        // Refinements in Algolia = the user's applied search options (like filters, facets, sorting) that narrow or change results.
        // https://www.algolia.com/doc/guides/building-search-ui/widgets/show-and-hide-widgets/react/?client=App.jsx
        preserveSharedStateOnUnmount: true
      }
    },
    /* @__PURE__ */ React.createElement(VirtualFacets, null),
    /* @__PURE__ */ React.createElement(Configure, { attributesToHighlight: [] }),
    children
  ));
}
export {
  AlgoliaProviders
};
//# sourceMappingURL=AlgoliaProviders.js.map
